export default "/static/build/skin-2nd.png";